// extracted by mini-css-extract-plugin
module.exports = {"subheader-divider":"style_subheader-divider__MPQMT"};